__turbopack_context__.v({
  "heroDisplay": "receptionist-module__ZIPpBG__heroDisplay",
  "range": "receptionist-module__ZIPpBG__range",
  "rc-ring": "receptionist-module__ZIPpBG__rc-ring",
  "ring": "receptionist-module__ZIPpBG__ring",
  "ringLate": "receptionist-module__ZIPpBG__ringLate",
});
